import { hydrateComplimentData } from './complimentEvents.js'

// Home's 200-row activity feed is not an all-time ranking source. Read the
// owner's full history in bounded pages, using the existing RLS-protected API.
export async function loadGatewayHistory(client, userId, pageSize = 500) {
  if (!userId) return []
  async function pages(table, columns, keys) {
    const rows = []
    for (let start = 0; ; start += pageSize) {
      let query = client.from(table).select(columns).eq('user_id', userId)
      for (const key of keys) query = query.order(key, { ascending: true })
      const { data, error } = await query.range(start, start + pageSize - 1)
      if (error) throw error
      rows.push(...(data || []))
      if ((data || []).length < pageSize) return rows
    }
  }
  const [wearLogs, events, wearContexts] = await Promise.all([
    pages('wear_logs', '*', ['id']),
    pages('compliment_events', 'id,wear_log_id', ['id']),
    pages('wear_log_context_tags', 'wear_log_id,context_tag', ['wear_log_id', 'context_tag']),
  ])
  return hydrateComplimentData(wearLogs, { events, wearContexts })
}
